<template>
    <div>
        <section class="main-bg-gradient top-panel skew">
            <div class="container inside-skew">
                <h1>
                    {{ $t('case.header') }}
                </h1>
                <p>
                    {{ $t('case.subheader') }}
                    <br><br>
                </p>
            </div>
        </section>
        <section class="bg-deveo-white">
            <div class="container other-cases" align="center">
                <h1 style="font-weight:300">{{ $t('case.otherTitle') }}</h1>
                <p>{{ $t('case.otherText') }}</p>
                <br><br>
                <ul>
                    <li class="cafelabonta">Café Labonta</li>
                    <li class="f2d">Fresh2Death</li>
                    <li class="farmsupportuganda">Farm Support Uganda </li>
                    <li class="fclarsen">FC Larsen A/S</li>
                    <li class="firmagavexperten">Firmagave<span>X</span>perten</li>
                    <li class="firmajulegaver">Firma<span>jule</span>gaver</li>
                    <li class="jyderupsandblaeseri">Jyderup Sandblæseri</li>
                    <li class="kunstnervaerkstedetroskilde">Kunstnerværkstedet Roskilde</li>
                    <li class="learninginclusive">Learning Inclusive</li>
                    <li class="ledberegner">LEDberegner.dk</li>
                    <li class="macramecopenhagen">Macrame Copenhagen</li>
                    <li class="oelstykkeerhvervsudlejning">Ølstykke Erhvervsudlejning</li>
                    <li class="peaksport">Peak Sport</li>
                    <li class="projectpoint">ProjectPoint</li>
                    <li class="sepeeg">SEPEEG</li>
                    <li class="solarvarme">Solarvarme</li>
                    <li class="styleguy">StyleGuy</li>
                    <li class="taastrupdyreklinik">Taastrup Dyreklinik</li>
                    <li class="tieman">TieMan</li>
                    <li class="toppaint">To<span>p</span><span class="red">p</span>a<span>i</span>nt</li>
                    <li class="touchrepair">TouchRep<span>a</span>ir</li>
                    <li class="vistasrevisor">Vistas Revisor</li>
                </ul>
            </div>
        </section>
    </div>
</template>
<style lang="scss" scoped>
    .other-cases{
        ul, ul *{
            cursor: default;
        }
        .oelstykkeerhvervsudlejning {
            color: rgb(233,95,38);
        }
        .learninginclusive{
            color: rgb(228,117,102);
        }
        .styleguy{
            color: rgb(84,131,165);
        }
        .tieman{
            color: rgb(195,150,75);
        }
        .macramecopenhagen{
            color: #000;
        }
        .firmagavexperten{
            color: rgb(51,51,51);
            span{
                color: rgb(178,21,33);
            }
        }
        .projectpoint{
            color: rgb(243,117,45);
        }
        .touchrepair{
            color: rgb(168,205,41);
            span{
                color: rgb(29,174,234);
            }
        }
        .firmajulegaver{
            color: rgb(45,45,45);
            span{
                color: rgb(151,4,11);
            }
        }
        .f2d{
            color: rgb(0,0,0);
        }
        .farmsupportuganda{
            color: rgb(102,197,160);
        }
        .taastrupdyreklinik{
            color: rgb(90,176,223);
        }
        .kunstnervaerkstedetroskilde{
            color: rgb(74,149,144);
        }
        .jyderupsandblaeseri{
            color: rgb(237,146,85);
        }
        .sepeeg{
            color: rgb(55,143,228);
        }
        .ledberegner{
            color: rgb(80,174,71);
        }
        .peaksport{
            color: rgb(229,214,47);
        }
        .toppaint{
            color: rgb(0,0,0);
            span{
                color: rgb(145,145,145);
            }
            span.red{
                color: rgb(226,32,41);
            }
        }
        .vistasrevisor{
            color: rgb(44,44,44);
        }
        .cafelabonta{
            color: rgb(196,170,111);
        }
        .fclarsen{
            color: rgb(23,76,149);
        }
        .solarvarme{
            color: rgb(48,93,134);
        }
    }
    $main-color: #2196f3;
    .main-color {
        color: $main-color;
    }
    .main-bg {
        background: $main-color;
    }
    .main-bg-gradient{
        background: linear-gradient(150deg, rgba(darken($main-color, 10%), 0.85) 15%, rgba(darken($main-color, 10%), 0.85) 70%), url('/static/images/bg.svg') top;
        background-size: cover;
    }
    h4, p{
        font-weight: 300;
    }
    ul{
        text-align: center;
    }
    li{
        display: inline-block;
        margin: 15px;
        font-weight: 300;
        font-size: 1.2rem;
        opacity: 0.75;
        transition: 0.3s ease all;
    }
    li:hover{
        cursor: default;
        opacity: 1;
        transform: scale(1.05);
    }
</style>
<script>
    import Case from '../components/case'
    import newCase from '../components/new-case'
    import VueImgLoader from 'vue-img-loader'
    export default {
        components: {
            Case,
            newCase,
            'vue-img-loader': VueImgLoader
        }
    }
</script>



// WEBPACK FOOTER //
// index.vue?da4deafa